// ============================================================
// icons.js
// ------------------------------------------------------------
// รหัสอักขระของไอคอน FontAwesome ที่ระบบใช้ (รวบรวมจากทุกหน้าจอในระบบเดิม)
// เดิมหน้าจอเขียนรหัส \uf304 ปนอยู่ในโค้ดโดยไม่รู้ว่าคือไอคอนอะไร
// ย้ายมาตั้งชื่อไว้ที่นี่ เวลาอ่านโค้ดจะเห็นเป็น ICON.edit / ICON.delete แทน
// ============================================================

export const ICON = {
  edit: "\uf304",          // ดินสอ — แก้ไข
  delete: "\uf2ed",        // ถังขยะ — ลบ
  change: "\uf70e",        // แลกเปลี่ยน — เปลี่ยนสัญญา
  excel: "\uf65b",         // ไฟล์ Excel — นำเข้า/ส่งออกไฟล์
  gear: "\uf013",          // เฟือง — ตั้งค่า
  close: "\uf00d",         // กากบาท — ปิด / ลบรูป
  eye: "\uf06e",           // ตา — แสดงรหัสผ่าน
  eye_slash: "\uf070",     // ตาขีด — ซ่อนรหัสผ่าน
  back: "\uf060",          // ลูกศรซ้าย — ย้อนกลับ
  user: "\uf007",          // คน — ผู้ใช้งาน
  menu: "\uf0c9",          // ขีดสามขีด — เปิด/ปิดเมนู
  upload: "\uf56f",        // ลูกศรขึ้น — อัปโหลด
  download: "\uf56d",      // ลูกศรลง — ดาวน์โหลด
  print: "\uf02f",         // เครื่องพิมพ์ — พิมพ์เอกสาร
  tag: "\uf02d",           // ป้าย — เล่ม/เลขที่เอกสาร
  map_marker: "\uf043",    // หมุด — ที่อยู่
  folder: "\uf07b",        // โฟลเดอร์ — หมวดหมู่
  info: "\uf05a",          // ตัว i — รายละเอียด
  pen: "\uf044",           // ปากกา — แก้ไขในตาราง
  paper: "\uf1f8",         // ถังขยะทึบ — ลบถาวร
  door: "\uf2f5",          // ประตู — ออกจากระบบ
  key: "\uf084",           // กุญแจ — เปลี่ยนรหัสผ่าน
  clock: "\uf017",         // นาฬิกา — เวลา
  building: "\uf543",      // อาคาร — โครงการ/อาคาร
};
